<div
  #dateInputBox
  class="phx-date-picker-input-box"
  [class.phx-input-focus]="dropdownOpen || focusedField"
  [class.phx-input-disabled]="phxDisabled"
  (keydown)="onKeyDown($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
  tabindex="0"
  phx-tooltip
  #inputTooltip="phxTooltip"
  [phxTitle]="tooltipTitle"
  [phxContent]="tooltipContent"
  [phxTrigger]="'none'"
  phxPlacement="top"
>
  <phx-date-picker
    class="phx-date-picker-input-trigger"
    [phxTriggerTemplate]="calendarTrigger"
    [phxDropdownOffset]="dropdownOffset"
    [phxOpen]="dropdownOpen"
    [phxMinSelectableDate]="phxMinSelectableDate"
    [phxMaxSelectableDate]="phxMaxSelectableDate"
    [phxEnabledDates]="phxEnabledDates"
    [phxEvents]="phxEvents"
    [phxDatesTooltip]="phxDatesTooltip"
    [phxHideClearButton]="!combinedValue"
    [(ngModel)]="internalDateValue"
    (phxOpenChange)="onDropdownVisibilityChange($event)"
    (ngModelChange)="onDatePickerChange($event)"
    (phxClear)="onClear()"
  ></phx-date-picker>
  <div class="phx-date-input phx-web-type-body-medium" [class.phx-placeholder]="isPlaceholder">
    <ng-container *ngFor="let field of displayFieldOrder; let i = index; let last = last">
      <span
        [class.phx-date-picker-input-focused]="focusedField === field"
        (mousedown)="setFocusedField(field)"
      >
        {{ getFormattedValue(field) }}
      </span>
      <span *ngIf="!last" class="phx-date-separator">{{ displaySeparators[i] }}</span>
    </ng-container>
  </div>
</div>

<ng-template #calendarTrigger>
  <button
    type="button"
    phx-icon-button
    tabindex="0"
    [phxIcon]="CalendarIcon"
    [phxIconButtonSize]="'extra-small'"
    [phxIconButtonType]="dropdownOpen ? 'accent' : 'default'"
    [disabled]="phxDisabled"
    class="phx-input-calendar-icon"
  ></button>
</ng-template>

<div class="phx-date-picker-input-error-message">{{ hasInternalError ? ('Please enter a valid date' | phxTranslate) : '' }}</div>
